module.exports = __webpack_public_path__ + "static/media/view-item.1f07fd53.png";